import { render, staticRenderFns } from "./free-delivery-message.vue?vue&type=template&id=592602d0"
import script from "./free-delivery-message.vue?vue&type=script&lang=js"
export * from "./free-delivery-message.vue?vue&type=script&lang=js"
import style0 from "./free-delivery-message.vue?vue&type=style&index=0&id=592602d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports